import { render } from "./Timeline.vue?vue&type=template&id=5a0aa2bf&scoped=true"
import script from "./Timeline.vue?vue&type=script&lang=js"
export * from "./Timeline.vue?vue&type=script&lang=js"

import "./Timeline.vue?vue&type=style&index=0&id=5a0aa2bf&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0aa2bf"]])

export default __exports__